import { render, staticRenderFns } from "./UIKit.vue?vue&type=template&id=393f5c0f&"
import script from "./UIKit.vue?vue&type=script&lang=js&"
export * from "./UIKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports